import './IdFormatContent.scss';

const IdFormatContent = () => {
  return (
    <div className="id-tooltip">
      <div className="id-tooltip__title">
        Рекомендуемый формат ID:
      </div>

      <div className="id-tooltip__code">
        <code>[Тип ПС][ID мерчанта][№ конфигурации]</code>
      </div>

      <div className="id-tooltip__title">
        Пример:
      </div>

      <div className="id-tooltip__code">
        <code>3400241</code>
      </div>

      <div className="id-tooltip__text">
        где:
      </div>

      <ul className="id-tooltip__list">
        <li><code>34</code> — тип ПС</li>
        <li><code>0024</code> — ID мерчанта (с ведущими нулями)</li>
        <li><code>1</code> — конфигурация</li>
      </ul>

      <div className="id-tooltip__text">
        Такой формат помогает поддерживать единообразие и упрощает управление конфигурациями.
      </div>

      <div className="id-tooltip__text">
        Для фиксированной длины допускаются ведущие нули.
      </div>
    </div>
  );
};

export default IdFormatContent;